import { useRef, useEffect } from 'react';
import whiteStarPic from '@/assets/images/white-star.png';
import Button from '@/components/Button';
import Card from '@/components/Card';
import Icon from '@/components/Icon';
import { ChevronRight } from 'lucide-react';

function Demo() {
    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!scrollRef.current) return;

        const scrollContainer = scrollRef.current;
        let animationFrameId: number;
        let startTime: number | null = null;
        const duration = 13000;

        const animate = (timestamp: number) => {
            if (!startTime) startTime = timestamp;
            const progress = ((timestamp - startTime) % duration) / duration;

            if (scrollContainer) {
                const translateX = progress * -100;
                scrollContainer.style.transform = `translateX(${translateX}%)`;
            }

            animationFrameId = requestAnimationFrame(animate);
        };

        animationFrameId = requestAnimationFrame(animate);

        return () => {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
        };
    }, []);


    return (
        <div className="py-16">
            <div className="flex items-center gap-3 mb-12">
                <img src={whiteStarPic} alt="Star" className="h-[24px] sm:h-[28px] md:h-[32px] lg:h-[36px] w-auto" />
                <h2 className="text-3xl font-bold">新闻动态</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {/* 新闻卡片示例 */}
                {[1, 2, 3, 4, 5, 6].map((item) => (
                    <Card key={item}>
                        <div className="aspect-video bg-gray-800 rounded-lg mb-4"></div>
                        <h3 className="text-xl font-semibold mb-2">新闻标题 {item}</h3>
                        <p className="text-gray-400 mb-4">新闻简介，描述新闻的主要内容...</p>
                        <div className="flex justify-between items-center text-sm text-gray-500">
                            <span>2024-03-{item}</span>
                            <Button variant="outline" size="sm">
                                阅读更多
                                <Icon icon={ChevronRight} size={16} className="ml-1" />
                            </Button>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
}

export default Demo;
